module.exports = __webpack_public_path__ + "img/icon-ai-generated.de72dfe2.svg";